import { useState, useRef, useEffect } from 'react';

import { Link, useSearchParams } from "react-router-dom";

import useWindowDimensions from '../Hooks/useWindowDimensions';
import VideoThumbnail from '../Assets/Images/video-thumbnail.png';
import PlayButton from '../Assets/Images/play-button.png';
import PlayButtonHover from '../Assets/Images/play-button-hover.png';
import Clock from '../Assets/Images/clock.png';

import '../App.scss';

const Start = props => {
  const { windowWidth }                   = useWindowDimensions();
  const [isLoading, setIsLoading]         = useState(true);

  const [searchParams, setSearchParams]   = useSearchParams();
  const [playingVideo, setPlayingVideo]   = useState(false);
  const [startPlaying, setStartPlaying]   = useState(false);
  const [playBtnImg, setPlayBtnImg]       = useState(PlayButton);
  searchParams.get("leader");
  const vidRef = useRef(null);

  // useEffect(() => { 
		// document.body.style.backgroundColor = "#122845";
	// },[]);

  const assessmentLink = () => {
    if(searchParams == "") {
      return "/assessment";
    } else {
      return "/assessment?" + searchParams;
    }
  }

  const playVideo = (e) => {
    console.log(vidRef.current);
    // vidRef.current.style.width = "70%";
    // console.log(document.getElementsByClassName("intro")[0]);
    if(windowWidth > 830) {
      document.getElementsByClassName("intro")[0].style.width = "0%";
      document.getElementsByClassName("intro")[0].style.padding = "0";
      document.getElementsByClassName("intro")[0].style.overflow = "hidden";
      document.getElementsByClassName("video")[0].style.width = "100%";
      document.getElementsByClassName("video")[0].style.margin = "0 auto";
      document.getElementsByClassName("video")[0].style.backgroundColor = "#21165A";
    }
    vidRef.current.play();
    setPlayingVideo(true);
    if(!startPlaying) {
      setStartPlaying(true);
    }
  }

  const pauseVideo = (e) => {
    console.log(vidRef.current);
    vidRef.current.pause();
    if(windowWidth > 830) {
      document.getElementsByClassName("intro")[0].style.width = "41%";
      document.getElementsByClassName("intro")[0].style.padding = "0 6%";
      document.getElementsByClassName("intro")[0].style.overflow = "hidden";
      document.getElementsByClassName("video")[0].style.width = "65%";
      document.getElementsByClassName("video")[0].style.margin = "0 auto";
      document.getElementsByClassName("video")[0].style.backgroundColor = "#000000";
    }
    setPlayingVideo(false);
  }

  const handleVideoPlaybackEnd = () => {
    setPlayingVideo(false);
    if(windowWidth > 830) {
      document.getElementsByClassName("intro")[0].style.width = "41%";
      document.getElementsByClassName("intro")[0].style.padding = "0 6%";
      document.getElementsByClassName("intro")[0].style.overflow = "hidden";
      document.getElementsByClassName("video")[0].style.width = "65%";
      document.getElementsByClassName("video")[0].style.margin = "0 auto";
      document.getElementsByClassName("video")[0].style.backgroundColor = "#000000";
    }
    showThumbnail();
    showPlayButton();
  }

  const showThumbnail = () => {
    if(playingVideo) {
      return <img className="thumbnail" src={VideoThumbnail} alt="thumbnail" style={{ opacity: '0'}} onClick={(e) => pauseVideo(e)} />;
    } else {
      if(startPlaying) {
        return null
      } else {
        return <img className="thumbnail" src={VideoThumbnail} alt="thumbnail" />
      }
    }
  }

  const showPlayButton = () => {
    if(playingVideo) {
      return null
    } else {
      return <img className="playbtn" src={playBtnImg} 
      onMouseEnter={() => setPlayBtnImg(PlayButtonHover)} onMouseLeave={() => setPlayBtnImg(PlayButton)} 
      
      onClick={(e) => playVideo(e)} alt="play button icon" />
    }
  }
  
  return (
    <div className="container start">
      <div className="video">
        <video ref={vidRef} onEnded={handleVideoPlaybackEnd}>
          <source
            src="https://40parables-assets.s3.amazonaws.com/Bleat-real-good-estate-assessment.mp4"
            type="video/mp4"
            />
        </video>
        {showThumbnail()}
        {showPlayButton()}
      </div>
      <div className="intro">
        <h1>Can your dream home become a reality?</h1>
        <h2>
        Take this assessment and help us match you with the perfect house that you can call home!
        </h2>
        <div className="completion">
          <Link to={assessmentLink()} className="cta">
            Get Started
          </Link>
          <div className='time-estimate'>
            <img className='clock-icon' src={Clock} alt="" /> <span>3 min</span>
          </div>
        </div>
        {/* <div className="completion">Estimated time for completion: 3 min</div> */}
      </div>
    </div>
  );
}
export default Start;